// Staff Assignment Models

export enum StaffStatus {
  Invited = 'Invited',
  Active = 'Active',
  Inactive = 'Inactive'
}

export enum AssignmentStatus {
  Active = 'Active',
  InActive = 'InActive'
}

export enum PlanStatus {
  Inactive = 'inactive',
  Active = 'active'
}

export enum PlanStaffAssignmentStatus {
  Active = 'Active',
  InActive = 'InActive'
}

export interface StaffAssignmentItem {
  assignment_id: number;
  staff_id: number;
  staff_name: string;
  staff_email: string;
  staff_mobile: string;
  staff_department: string;
  staff_designation: string;
  staff_status: StaffStatus;
  assignment_status: AssignmentStatus;
  is_active: boolean;
  assigned_at: string;
}

export interface StaffAssignmentResponse {
  items: StaffAssignmentItem[];
  statistics: StaffAssignmentItem[];
  total_items: number;
  total_pages: number;
  current_page: number;
}

export interface AssignStaffRequest {
  staff_id: number;
}

export interface RemoveStaffAssignmentRequest {
  assignment_id: number;
}

// Staff Plan Assignment Models (for new list page)
export interface StaffPlanItem {
  plan_id: number;
  plan_name: string;
  plan_freq: string;
  plan_status: PlanStatus;
  plan_staff_assignment_status: PlanStaffAssignmentStatus;
  plan_start_date: string;
  plan_end_date: string;
}

export interface StaffWithPlans {
  staff_id: number;
  staff_name: string;
  staff_email: string;
  staff_mobile: string;
  staff_department: string;
  staff_designation: string;
  staff_status: StaffStatus;
  plans: StaffPlanItem[];
}

export interface StaffPlanAssignmentsResponse {
  items: StaffWithPlans[];
  statistics: StaffWithPlans[];
  total_items: number;
  total_pages: number;
  current_page: number;
}

export interface AssignPlanToStaffRequest {
  staff_ids: number[];
}

